// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBoxPreview_wrapper__1r1UN","thumbnail":"LightBoxPreview_thumbnail__1X39e","hoverImage":"LightBoxPreview_hoverImage__35wY8","btn":"LightBoxPreview_btn__2JcsM"};